import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  NgModule,
  OnDestroy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NavItem } from '@models/menu/menu';
import { WINDOW } from '@wizbii/angular-utilities';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { BehaviorSubject } from 'rxjs';

enum PopupPositionEnum {
  Middle = 0,
  Left = 1,
  Right = 2,
}
@Component({
  selector: 'app-dropdown-nav',
  templateUrl: './dropdown-nav.component.html',
  styleUrls: ['./dropdown-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownNavComponent implements AfterViewInit, OnDestroy {
  static readonly leftOffset = 30;
  static readonly rightOffset = 260;

  @Input() dropdownNav!: NavItem;

  timeout: any;

  hovered$ = new BehaviorSubject<boolean>(false);
  inDropdown$ = new BehaviorSubject<boolean>(false);
  position$ = new BehaviorSubject<PopupPositionEnum>(PopupPositionEnum.Middle);
  PopupPositionEnum = PopupPositionEnum;

  trackEvent = trackEventWithAtInternet;

  constructor(@Inject(WINDOW) private readonly window: any, private readonly elm: ElementRef) {}

  ngAfterViewInit(): void {
    this.window.setTimeout(() => {
      const { left, right } = this.elm.nativeElement.getBoundingClientRect();

      this.computePopupPosition(left, right, this.window.innerWidth);
    });
  }

  updateHovered(value: boolean): void {
    if (this.hovered$.value !== value && !value) {
      this.timeout = this.window.setTimeout(() => {
        this.hovered$.next(value);
      }, 300);
    } else if (this.hovered$.value !== value && value) {
      this.hovered$.next(value);
    }
  }

  updateDropdown(): void {
    this.hovered$.next(!this.hovered$.value);
  }

  updateInDropdown(value: boolean): void {
    this.window.clearTimeout(this.timeout);
    this.inDropdown$.next(value);

    if (!value) {
      this.hovered$.next(value);
    }
  }

  onBlur(isLast: boolean): void {
    this.hovered$.next(!isLast);
  }

  trackByDropdownItem(_: number, item: NavItem): string {
    return item.label;
  }

  private computePopupPosition(leftPos: number, rightPos: number, windowWidth: number): void {
    if (leftPos < DropdownNavComponent.leftOffset) {
      this.position$.next(PopupPositionEnum.Left);
    }

    if (windowWidth - rightPos < DropdownNavComponent.rightOffset) {
      this.position$.next(PopupPositionEnum.Right);
    }
  }

  ngOnDestroy(): void {
    this.hovered$.complete();
    this.inDropdown$.complete();
    this.position$.complete();
  }
}

@NgModule({
  imports: [CommonModule, RouterModule, MatIconModule],
  declarations: [DropdownNavComponent],
  exports: [DropdownNavComponent],
})
export class DropdownNavModule {}
